import { render } from "./IconCloseHamburger.vue?vue&type=template&id=67b61505"
import script from "./IconCloseHamburger.vue?vue&type=script&lang=js"
export * from "./IconCloseHamburger.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__